export const MAPBOX_SETTINGS = {
  center: [8.19, 46.82],
  bounds: [[4.37, 45.8], [11.97, 47.8]],
  boundsMobile: [[5.5, 45], [11, 48.5]],
  // token:
  //   'pk.eyJ1IjoidGEtaW50ZXJha3RpdiIsImEiOiJjaXNhNGFsdHAwMDB2Mm9wNWdlMTlqMTNuIn0.uj5aGvF3yvEM4V6kNdlbVg',
  style: 'images/tamedia_hazard.json'
}

export const NOMINATIMPROPS = {
  limit: 12,
  countrycodes: 'ch',
  format: 'json',
  addressdetails: 1,
  dedupe: 1,
  extratags: 0,
  namedetails: 1,
  email: 'interaktiv@tagesanzeiger.ch',
  'accept-language': ['de-ch', 'de'],
  viewbox: '',
  // eslint-disable-next-line @typescript-eslint/camelcase
  polygon_geojson: 1,
  q: ''
}
export const MAXRESULTZOOM = 19

export const AREAMARKERPROPS = {
  lineColor: '#0071ac',
  lineWidth: 3
}
export const HAZARDLAYERS = [
  'haz_ava_subst',
  'haz_ava_mean',
  'haz_ava_slight',
  'haz_water_subst',
  'haz_water_mean',
  'haz_water_slight'
]
export const CANTONSNODATA = []
export const LAYERSPERCANTON = [
  '_water_subst',
  '_water_mean',
  '_water_slight',
  '_ava_subst',
  '_ava_mean',
  '_ava_slight'
]
